module.exports = __webpack_public_path__ + "static/media/get-refund-icon.8b69135a.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/get-refund-icon.svg
// module id = 1404
// module chunks = 0